window.PlummeI18n.register('en', {
  'adv.cost.review': 'Review',
  'adv.cost.moreTitle': 'More opportunities',
  'adv.cost.observedValue': 'Observed value',
  'adv.cost.invoiceBasis': 'Invoice basis',
  'adv.cost.draftValue': 'Draft value',
  'adv.cost.possibleCount': 'Possible duplicates',
  'adv.cost.purchaseShare': 'Purchase share',
  'adv.cost.givenDiscount': 'Discount given',
  'adv.cost.unbilledNote': 'Invoice basis, not booked income',
  'adv.cost.draftNote': 'Draft value, not booked income',
  'adv.cost.acceptedNote': 'Accepted offers without a linked invoice',
  'adv.cost.duplicateNote': 'Possible duplicates to review',
  'adv.cost.supplierNote': 'Purchase volume that may support a negotiation',
  'adv.cost.discountTitle': 'Review discounts given',
  'adv.cost.discountNote': 'Discounts actually given, not estimated savings',
  'adv.cost.voucherNote': 'Documentation to follow up; no estimated savings',
  'adv.cost.followUp': 'To follow up',
  'adv.cost.increaseToReview': 'Increase to review',
  'adv.cost.fixedTitle': 'Booked fixed costs',
  'adv.cost.tryAdjustment': 'Try an adjustment',
  'adv.cost.fixedDetail': 'Monthly average based on {months} complete months',
  'adv.cost.otherTitle': 'Largest other cost accounts',
  'adv.cost.otherIntro': 'The share compares booked cost with revenue in the selected year. It is not an estimated saving, and the account is not automatically classified as variable.',
  'adv.cost.otherDetail': '{amount} booked in the selected year',
  'adv.cost.ofRevenue': 'of revenue',
  'adv.cost.noRevenueShare': 'Share not calculated',
  'adv.cost.sub': 'Largest booked cost accounts and change against last year',
  'adv.cost.subPeriod': 'Largest booked cost accounts and change against the same period last year',
  'adv.cost.help': 'Accounts come from the income statement for the selected year. Bars show the booked amount by account. Change is shown only when the same account has a positive amount last year.',
  'adv.cost.helpPeriod': 'Accounts come from the income statement through the current month. Bars show the booked amount by account. Change is compared with the same period last year when the account had a positive amount.',
  'adv.cost.rowHelp': 'Booked to this account: {amount} in the selected year. Change against last year: {change}.',
  'adv.cost.noComparison': 'No prior-year figure',
  'adv.cost.emptyText': 'No booked cost accounts in the selected year.',
  'adv.cost.flagText': '{name} has risen substantially against last year. Check whether the change was planned and review the postings in this account.',
  'adv.why.costSub': 'Cost accounts that have risen substantially against last year',
});
